import React from "react";
import LWTooltip, { LWTooltipProps } from "./LWTooltip";

const HoverOver = (props: LWTooltipProps) => {
  return <LWTooltip {...props} />
}

export default HoverOver;


